<template>
  <nav
    class="navbar navbar-expand navbar-light bg-white shadow-sm component-menubar-navbar"
    :style="navbarStyle"
  >
    <ul id="navbar-left" class="navbar-nav">
      <li class="nav-item">
        <a
          class="nav-link"
          href="#"
          @click.prevent="toggleSidebar"
        >
          <i class="fas fa-bars"></i>
        </a>
      </li>
      <li
        class="nav-item"
        v-if="
          onQueueRoute && isAccessMenu([ROLES.MANAGER, ROLES.COUNTER, ROLES.HEADCOUNTER])
        "
      >
        <a href="#" class="nav-link" data-testid="new-patient-button" @click="openCustomerModal">
          <i class="fa fa-user-plus" aria-hidden="true"></i> คนไข้ใหม่
        </a>
      </li>

      <li
        class="nav-item"
        v-if="
          (onQueueRoute || onDoctorsTxQRoute) &&
          isAccessMenu([ROLES.MANAGER, ROLES.COUNTER, ROLES.ASSISTANT, ROLES.HEADCOUNTER])
        "
      >
        <a href="#" class="nav-link" data-testid="patient-search-button" @click="openSearchCustomerModal">
          <i class="fa fa-search" aria-hidden="true"></i> ค้นหาคนไข้
        </a>
      </li>
    </ul>
    
    <!-- Navbar brand (center) -->
    <div class="navbar-brand mx-auto d-flex align-items-center">
      <Logo
        class="logo d-none d-sm-inline-block mr-2"
        :src="logoUrl"
        :alt="clinicName"
      />
      <h5 class="text-muted mb-0 d-none d-sm-inline-block">
        {{ `${clinicName}`
        }}<span v-if="branchName" class="ml-2">({{ `${branchName}` }})</span>
      </h5>
    </div>
    
    <!-- Right navbar items -->
    <ul class="navbar-nav">
      <li v-if="isStaging" class="nav-item">
        <a href="#" class="nav-link">
          token <CopyToClipboard :text="accessToken" />
        </a>
      </li>
      <li class="nav-item">
        <a id="soundLockedIcon" href="#" class="nav-link">
          <i v-if="soundUnlocked && volume > 0" class="fas fa-volume-up"></i>
          <i v-else class="fas fa-volume-mute"></i>
        </a>
      </li>
      <b-popover
        target="soundLockedIcon"
        placement="bottomleft"
        triggers="click blur"
      >
        <b-form-input
          class="mb-0"
          type="range"
          :min="0"
          :max="0.6"
          :step="0.05"
          v-model="volume"
          @change="emitVolume"
        ></b-form-input>
      </b-popover>
      <li id="todoNotification" class="nav-item d-none d-sm-inline-block">
        <a
          v-if="
            (onQueueRoute || onDoctorsTxQRoute) &&
            isAccessMenu([ROLES.MANAGER, ROLES.COUNTER, ROLES.ASSISTANT, ROLES.HEADCOUNTER])
          "
          href="#"
          class="nav-link"
        >
          <i class="fas fa-bell"></i>
          <b-badge v-if="todoNumber" variant="warning" class="ml-1">{{
            todoNumber
          }}</b-badge>
        </a>
      </li>

      <li class="nav-item">
        <b-dropdown
          size="lg"
          variant="link"
          right
          toggle-class="text-decoration-none p-0"
          no-caret
        >
          <template v-slot:button-content>
            <b-avatar
              :variant="profileInfo.contentId ? 'white' : 'info'"
              class="elevation-2"
              :text="abbreviation"
              alt="User Image"
              size="2.4rem"
              :src="viewFile(profileInfo.contentId)"
            ></b-avatar>
          </template>
          <b-dropdown-text style="width: 240px">
            <div class="user-panel d-flex">
              <div class="image pl-0">
                <b-avatar
                  :variant="profileInfo.contentId ? 'white' : 'info'"
                  :text="abbreviation"
                  alt="User Image"
                  size="2.4rem"
                  :src="viewFile(profileInfo.contentId)"
                ></b-avatar>
              </div>
              <div class="info">
                <div>
                  {{ `${profileInfo.firstNameTh} ${profileInfo.lastNameTh}` }}
                </div>
              </div>
            </div>
          </b-dropdown-text>
          <b-dropdown-divider></b-dropdown-divider>
          <!-- <b-dropdown-item href="/user/profile"> -->
          <b-dropdown-item @click="openUserProfileModal">
            <i class="fas fa-user-edit"></i>
            ข้อมูลผู้ใช้
          </b-dropdown-item>
          <b-dropdown-item href="/clinic">
            <i class="fas fa-clinic-medical"></i>
            เลือกคลินิก/สาขา
          </b-dropdown-item>
          <!-- <b-dropdown-item href="#">
            <img style="width: auto; height: 24px" :src="MorFunDeeLogo" />
            เข้าระบบ MorFunDee
          </b-dropdown-item>
          <b-dropdown-item href="#">
            <img style="width: auto; height: 24px" :src="TTDLogo" />
            เข้าระบบ Thaiteledentistry
          </b-dropdown-item> -->
          <b-dropdown-item href="/logout">
            <i class="fas fa-sign-out-alt"></i>
            ออกจากระบบ
          </b-dropdown-item>
        </b-dropdown>
      </li>
    </ul>
    <b-popover
      id="todoPopover"
      ref="todoPopover"
      title="เตือนนัดหมายวันพรุ่งนี้"
      target="todoNotification"
      triggers="hover"
      placement="bottomleft"
    >
      <div>
        <div>
          <b-card
            class="mb-1 pointer"
            body-class="p-2"
            :border-variant="stsCount[1] === 0 ? 'success' : 'warning'"
            @click="routeQueueList('status')"
          >
            <b-row>
              <b-col cols="2" class="text-center"
                ><i
                  class="fas fa-phone fa-2x pt-2"
                  :class="stsCount[1] === 0 ? 'text-success' : 'text-warning'"
                ></i>
              </b-col>
              <b-col cols="" class="pl-2 text-center">
                <span v-if="stsCount[1] != 0"
                  >โทรยืนยันนัดหมายอีก {{ stsCount[1] }} ราย</span
                >
                <span v-else>ยืนยันนัดหมายทั้งหมดแล้ว</span>
                <b-progress
                  class="mt-2"
                  :max="stsCount.sum == null ? 1 : stsCount.sum"
                >
                  <b-progress-bar
                    :value="stsCount.sum == null ? 1 : stsCount[2]"
                    variant="success"
                    :animated="true"
                  ></b-progress-bar>
                  <b-progress-bar
                    :value="stsCount.sum - stsCount[1] - stsCount[2]"
                    variant="secondary"
                    :animated="true"
                  ></b-progress-bar>
                  <b-progress-bar
                    :value="stsCount[1]"
                    variant="warning"
                    :animated="true"
                    show-value
                  ></b-progress-bar>
                </b-progress>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            class="mb-0 pointer"
            body-class="p-2"
            :border-variant="rmdCount.inc === 0 ? 'success' : 'warning'"
            @click="routeQueueList('reminder')"
          >
            <b-row>
              <b-col cols="2" class="text-center"
                ><i
                  class="fas fa-tooth fa-2x pt-2"
                  :class="rmdCount.inc === 0 ? 'text-success' : 'text-warning'"
                ></i>
              </b-col>
              <b-col cols="" class="pl-2 text-center">
                <span v-if="rmdCount.inc != 0"
                  >มีรายการแจ้งเตือน {{ rmdCount.inc }} ราย</span
                >
                <span v-else>ไม่มีรายการแจ้งเตือน</span>
                <b-progress
                  class="mt-2"
                  :max="rmdCount.sum == null ? 1 : rmdCount.sum"
                >
                  <b-progress-bar
                    :value="
                      rmdCount.sum == null ? 1 : rmdCount.sum - rmdCount.inc
                    "
                    variant="success"
                    :animated="true"
                  ></b-progress-bar>
                  <b-progress-bar
                    :value="rmdCount.inc"
                    variant="warning"
                    :animated="true"
                    show-value
                  ></b-progress-bar>
                </b-progress> </b-col
            ></b-row>
          </b-card>
        </div>
      </div>
    </b-popover>
    <UserProfileModal ref="userProfileModal" />
  </nav>
</template>

<script>
import { eventBus } from "@/main";
import { mapGetters, mapActions } from "vuex";
import { ROLES } from "@/constants/user";
import UserProfileModal from "@/components/modal/UserProfile";
import get from "lodash/get";
import moment from "moment";
import Logo from "@/components/Logo";
import MorFunDeeLogo from "../../assets/img/morfundee-logo.png";
import TTDLogo from "../../assets/img/thai-teledentistry-logo.png";
import CopyToClipboard from "@/components/CopyToClipboard";

export default {
  name: "Navbar",
  components: {
    UserProfileModal,
    Logo,
    CopyToClipboard,
  },
  data() {
    return {
      ROLES,
      profileInfo: {},
      tomorrow: moment().add(1, "days").format("YYYY-MM-DD"),
      soundUnlocked: false,
      volume: 0.6,
      sidebarCollapsed: false,
      MorFunDeeLogo,
      TTDLogo,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      authorization: "moduleUser/getAuthorization",
      userInfo: "moduleUser/getUserInfo",
      viewFile: "moduleContent/viewFile",
      isAccessMenu: "moduleUser/getIsAccessMenu",
      getBranchInfo: "moduleUser/getBranchInfo",
      getClinicList: "moduleUser/getClinicList",
      getAppointmentStatusList: "moduleMaster/getAppointmentStatusList",
      getTomorrowAppointmentList:
        "moduleAppointment/getTomorrowAppointmentList",
      getReminderList: "moduleMaster/getReminderList",
      getAccessToken: "moduleAuth/getAccessToken",
    }),
    isCentralRoute() {
      return ["ClinicCentral", "ClinicManagement", "ClinicDashboard", "CentralBranchDashboard"].includes(this.$route.name);
    },
    centralClinic() {
      return (this.getClinicList || []).find(
        c => c.code === this.$route.params.clinicUrl
      );
    },
    branchName() {
      if (this.isCentralRoute) {
        return "ระดับคลินิก";
      }
      return get(this.getBranchInfo, "name") || "";
    },
    clinicName() {
      if (this.isCentralRoute) {
        return get(this.centralClinic, "name") || "";
      }
      return get(this.getBranchInfo, "clinic.name") || "";
    },
    // logoUrl() {
    //   return get(this.getBranchInfo, "clinic.logoUrl") || "";
    // },
    abbreviation() {
      if (
        this.profileInfo &&
        (this.profileInfo.firstNameEn || this.profileInfo.lastNameEn)
      ) {
        var firstName = "";
        var lastName = "";
        if (this.profileInfo.firstNameEn) {
          firstName = this.profileInfo.firstNameEn.charAt(0);
        }
        if (this.profileInfo.lastNameEn) {
          lastName = this.profileInfo.lastNameEn.charAt(0);
        }
        return `${firstName}${lastName}`;
      } else {
        return "";
      }
    },
    isDoctor() {
      return this.authorization.authId === 2;
    },
    onQueueRoute() {
      return (
        this.$route.name === "QueueManage" || this.$route.name === "QueueList"
      );
    },
    onDashboardRoute() {
      return this.$route.name === "Dashboard";
    },
    onDoctorsTxQRoute() {
      return this.$route.name === "DoctorsTreatingQueue";
    },
    stsCount() {
      return this.statusCount();
    },
    rmdCount() {
      return this.reminderCount();
    },
    todoNumber() {
      return this.stsCount[1] + this.rmdCount.inc || 0;
    },
    logoUrl() {
      if (this.isCentralRoute) {
        return this.centralClinic?.logo
          ? this.viewFile(this.centralClinic.logo)
          : "";
      }
      if (this.getBranchInfo?.clinic?.logo) {
        return this.viewFile(this.getBranchInfo.clinic.logo);
      }
      return "";
    },
    isStaging() {
      return ["staging", "dev"].includes(process.env.VUE_APP_MODE);
    },
    accessToken() {
      return localStorage.getItem("access_token");
    },
    navbarStyle() {
      // On mobile, always full width
      if (window.innerWidth <= 768) {
        return {
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
          zIndex: 999,
          height: '56px',
          width: '100%'
        };
      }
      
      // On desktop: adjust based on sidebar state
      const sidebarWidth = this.sidebarCollapsed ? '60px' : '0px'; // 0px when expanded (overlay mode)
      return {
        position: 'fixed',
        top: '0',
        left: sidebarWidth,
        right: '0',
        zIndex: 999,
        height: '56px',
        width: `calc(100% - ${sidebarWidth})`,
        transition: 'left 0.3s ease, width 0.3s ease'
      };
    },
  },
  methods: {
    ...mapActions({
      fetchAllConfig: "moduleMaster/fetchAllConfig",
    }),
    init() {
      this.fetchAllConfig();
      eventBus.$on("updateProfile", userInfo => {
        this.profileInfo = userInfo || {};
      });
    },
    openCustomerModal() {
      eventBus.$emit("openCustomerModal");
    },
    openSearchCustomerModal() {
      eventBus.$emit("openSearchCustomerModal");
    },
    openUserProfileModal() {
      this.$refs.userProfileModal.show();
    },
    async routeQueueList(arg) {
      if (this.$route.name !== "QueueList") {
        await this.$router.push({ path: "/queuelist" });
      }
      eventBus.$emit("todoClick", arg);
    },
    statusCount() {
      let status = this.getTomorrowAppointmentList.reduce((acc, apt) => {
        if (typeof acc[apt.extendedProps.statusId] == "undefined") {
          acc[apt.extendedProps.statusId] = 1;
        } else {
          acc[apt.extendedProps.statusId] += 1;
        }
        !acc.sum ? (acc.sum = 1) : (acc.sum += 1);
        return acc;
      }, {});
      if (!status[1]) {
        status[1] = 0;
      }
      return status;
    },
    reminderCount() {
      let reminder = this.getTomorrowAppointmentList.reduce((acc, apt) => {
        if (typeof acc[apt.extendedProps.rmdId] == "undefined") {
          acc[apt.extendedProps.rmdId] = 1;
        } else {
          acc[apt.extendedProps.rmdId] += 1;
        }
        if (apt.extendedProps.rmdId != null) {
          !acc.sum ? (acc.sum = 1) : (acc.sum += 1);
        }
        return acc;
      }, {});
      let incomplete = 0;
      for (let key in reminder) {
        if (key > 0 && key <= 10) {
          incomplete += reminder[key];
        }
      }
      reminder.inc = incomplete;
      return reminder;
    },
    findStatusObj(statusId) {
      return this.getAppointmentStatusList.find(function (item) {
        return item["code"] == statusId;
      });
    },
    findReminderObj(rmdId) {
      return this.getReminderList.find(function (item) {
        return item["val"] == rmdId;
      });
    },
    emitVolume(vol) {
      eventBus.$emit("adjustVolume", vol);
    },
    toggleSidebar(event) {
      // Handle mobile sidebar toggle via CSS class
      if (window.innerWidth <= 768) {
        document.body.classList.toggle('mobile-sidebar-open');
      } else {
        // For desktop, emit event to sidebar component
        eventBus.$emit("toggleSidebar");
      }
    },
  },
  mounted() {
    this.profileInfo = this.userInfo || {};
    eventBus.$on("soundUnlocked", e => {
      this.soundUnlocked = e;
    });
    // Listen for sidebar state changes to update navbar positioning
    eventBus.$on("sidebarStateChanged", (collapsed) => {
      this.sidebarCollapsed = collapsed;
    });
    this.volume = parseFloat(localStorage.getItem("volume") || "0.6");
  },
  destroyed() {
    eventBus.$off("sidebarStateChanged");
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.logo {
  max-height: 30px;
  width: auto;
}
</style>